import { admGraphqlRequest } from 'core/utils/backend-service';
import {
    deleteCustomAlarmDefinitionsMutation,
    getCustomAlarmDefinitionsQuery,
    updateCustomAlarmsActiveStatusMutation,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/service/custom-alarm-list.queries';
import { CustomAlarmDefinition } from 'modules/settings/pods/settings-devices/settings-devices-configuration/domain/custom-alarm-definition.vm';
import { mapCustomAlarmDefinitionsFromApi } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/service/custom-alarm-list.mapper';

export const getCustomAlarmDefinitions = (
    deviceTypeId: string,
    onlyActive: boolean
): Promise<CustomAlarmDefinition[]> =>
    admGraphqlRequest(getCustomAlarmDefinitionsQuery(), {
        type: 'DEVICE_TYPE',
        domainEntityId: deviceTypeId,
        onlyActive,
    }).then((result) => mapCustomAlarmDefinitionsFromApi(result.data.customAlarmDefinitions));

export const deleteCustomAlarmDefinitions = (ids: string[]): Promise<void> =>
    admGraphqlRequest(deleteCustomAlarmDefinitionsMutation(), { ids }).then(
        (result) => result.data.deleteCustomAlarmDefinitions
    );

export const updateCustomAlarmsActiveStatus = (ids: string[], active: boolean): Promise<void> =>
    admGraphqlRequest(updateCustomAlarmsActiveStatusMutation(), { ids, active }).then(
        (result) => result.data.updateCustomAlarmDefinitionsActiveStatus
    );
